// extracted by mini-css-extract-plugin
module.exports = {"team":"style_team__nahRA","teamLogo":"style_teamLogo__nGl5F","name":"style_name__zsbpM"};